export default __webpack_public_path__ + "static/tree-fc41fa18f16cf495192d84fcef2adb73.png";